export const ROUTE_HOME = "Home" as const;
export const ROUTE_INBOX = "Inbox" as const;
export const ROUTE_INBOX_CALLS = "InboxCalls" as const;
export const ROUTE_ACCOUNT = "Account" as const;
export const ROUTE_AI_AGENTS = "AIAgents" as const;
export const ROUTE_BORROWER_PLATFORM_BUILDER =
  "BorrowerPlatformBuilder" as const;
export const ROUTE_BUSINESSES = "Businesses" as const;
export const ROUTE_BUSINESS_ENTITY_PROFILE = "BusinessEntityProfile" as const;
export const ROUTE_BUSINESS_PROFILE_DEALS = "BusinessProfileDeals" as const;
export const ROUTE_BUSINESS_PROFILE_INFO = "BusinessProfileInfo" as const;
export const ROUTE_BUSINESS_RELATIONS = "BusinessRelations" as const;
export const ROUTE_BUSINESS_TRACKING = "BusinessTracking" as const;
export const ROUTE_CHECKOUT_BUILDER = "CheckoutBuilder" as const;
export const ROUTE_CLIENT_SETTINGS = "ClientSettings" as const;
export const ROUTE_CONTRACTS = "Contracts" as const;
export const ROUTE_CONTRACT_BUILDER = "ContractBuilder" as const;
export const ROUTE_CONTRACT_BUILDER_EDIT = "ContractBuilderEdit" as const;
export const ROUTE_CONTRACT_BUILDER_NEW = "ContractBuilderNew" as const;
export const ROUTE_CUSTOM_ATTRIBUTES_BUILDER_VIEW =
  "CustomAttributeBuilderView" as const;
export const ROUTE_CUSTOM_WEBHOOKS = "CustomWebhookTemplates" as const;
export const ROUTE_CUSTOM_WEBHOOKS_VIEW = "CustomWebhookTemplatesView" as const;
export const ROUTE_CUSTOM_WEBHOOKS_NEW = "CustomWebhookTemplatesNew" as const;
export const ROUTE_CUSTOM_WEBHOOKS_EDIT = "CustomWebhookTemplatesEdit" as const;
export const ROUTE_DEALS = "Deals" as const;
export const ROUTE_DEAL_ACTIVITY = "DealActivity" as const;
export const ROUTE_DEAL_DOCUMENTS = "DealDocuments" as const;
export const ROUTE_DEAL_TRACKING = "Tracking" as const;
export const ROUTE_DEAL_LINKS = "ApplicationLinks" as const;
export const ROUTE_DEAL_PROGRESS = "DealProgress" as const;
export const ROUTE_DOCUMENTS = "Documents" as const;
export const ROUTE_EMAIL_INTEGRATION = "EmailIntegration" as const;
export const ROUTE_EMAIL_TEMPLATES = "EmailTemplates" as const;
export const ROUTE_KEYBOARD_SHORTCUTS = "KeyboardShortcuts" as const;
export const ROUTE_ACCESS_TOKENS = "AccessTokens" as const;
export const ROUTE_ACCESS_TOKENS_CREATE = "AccessTokensCreate" as const;
export const ROUTE_EMAIL_TEMPLATES_EDIT = "EmailTemplatesEdit" as const;
export const ROUTE_EMAIL_TEMPLATES_NEW = "EmailTemplatesNew" as const;
export const ROUTE_ERC_REPORTS = "ErcReports" as const;
export const ROUTE_FUNDER_DETAILS = "Funder-Details" as const;
export const ROUTE_FUNDER_SETTINGS = "FunderSettings" as const;
export const ROUTE_INDIVIDUAL_PROFILE = "IndividualProfile" as const;
export const ROUTE_INDIVIDUAL_PROFILE_DEALS = "IndividualProfileDeals" as const;
export const ROUTE_INDIVIDUAL_PROFILE_PERSONAL_INFO =
  "IndividualProfilePersonalInfo" as const;
export const ROUTE_INDIVIDUAL_PROFILE_TRACKING =
  "IndividualProfileTrackingTab" as const;
export const ROUTE_INDIVIDUAL_RELATIONS = "IndividualRelations" as const;
export const ROUTE_INTEGRATIONS = "Integrations" as const;
export const ROUTE_INTEGRATIONS_BORROWER_PLATFORM =
  "BorrowerPlatformIntegration" as const;
export const ROUTE_INTEGRATIONS_DATA_PROVIDER = "DataIntegration" as const;
export const ROUTE_INTEGRATIONS_FUNDER = "FunderIntegration" as const;
export const ROUTE_INTEGRATIONS_ORIGINATION = "OriginationIntegration" as const;
export const ROUTE_INTEGRATIONS_SERVICE_PROVIDER =
  "LendingServiceProvider" as const;
export const ROUTE_INTEGRATIONS_WIDGET = "WidgetIntegration" as const;
export const ROUTE_ORCHESTRATION_LIST = "Orchestration" as const;
export const ROUTE_ORCHESTRATION_TEMPLATE =
  "OrchestrationTemplateView" as const;
export const ROUTE_ORGANIZATION = "Organization" as const;
export const ROUTE_PAGE_NOT_FOUND = "PageNotFound" as const;
export const ROUTE_SCORECARDS_BACKTEST_REPORT_EDIT =
  "ScorecardsBacktestReportEdit" as const;
export const ROUTE_SCORECARDS_BACKTEST_REPORT_VIEW =
  "ScorecardsBacktestReportView" as const;
export const ROUTE_SCORECARDS_BUILDER_VIEW = "ScorecardsBuilder" as const;
export const ROUTE_SCORECARDS_GROUP_NEW = "ScorecardsGroupNew" as const;
export const ROUTE_SMS_TEMPLATES_VIEW = "SmsTemplatesView" as const;
export const ROUTE_SMS_TEMPLATES = "SmsTemplates" as const;
export const ROUTE_SMS_TEMPLATES_EDIT = "SmsTemplatesEdit" as const;
export const ROUTE_SMS_TEMPLATES_NEW = "SmsTemplatesNew" as const;
export const ROUTE_WIDGET_BRANDING = "WidgetBranding" as const;
export const ROUTE_WIDGET_BRANDING_TEMPLATE = "WidgetBrandingTemplate" as const;
export const ROUTE_WIDGET_BRANDING_TEMPLATE_CREATE =
  "WidgetBrandingTemplateCreate" as const;
export const ROUTE_WIDGET_BRANDING_CONSENT_TEMPLATE_LIST =
  "WidgetBrandingConsentTemplateList" as const;
export const ROUTE_WIDGET_BRANDING_CONSENT_TEMPLATE_EDIT =
  "WidgetBrandingConsentTemplateEditor" as const;
export const ROUTE_BUILDERS_CONSENT_TEMPLATE_LIST =
  "BuildersConsentTemplateList" as const;
export const ROUTE_BUILDERS_CONSENT_TEMPLATE_EDIT =
  "BuildersConsentTemplateEdit" as const;
export const ROUTE_WORKFLOW_BUILDER = "WorkflowBuilder" as const;
export const ROUTE_WORKFLOW_BUILDER_CONTENT = "WorkflowBuilderContent" as const;
export const ROUTE_WORKFLOW_BUILDER_NOTIFICATIONS_EMAIL =
  "WorkflowBuilderNotificationsEmail" as const;
export const ROUTE_WORKFLOW_BUILDER_NOTIFICATIONS_SMS =
  "WorkflowBuilderNotificationsSms" as const;
export const ROUTE_WORKFLOW_BUILDER_NOTIFICATIONS_WEBHOOKS =
  "WorkflowBuilderNotificationsWebhooks" as const;
export const ROUTE_WORKFLOW_BUILDER_SETTINGS =
  "WorkflowBuilderSettings" as const;
export const ROUTE_WORKFLOW_BUILDER_SETTINGS_VIEW =
  "WorkflowBuilderSettingsView" as const;
export const ROUTE_WORKFLOW_BUILDER_SUBMISSION =
  "WorkflowBuilderEmailSubmission" as const;
export const ROUTE_WORKFLOW_BUILDER_DOC_SYNC =
  "WorkflowBuilderDocSync" as const;
export const ROUTE_WORKFLOW_BUILDER_ACTIVITY_HUB =
  "WorkflowBuilderActivityHub" as const;
export const ROUTE_WORKFLOW_BUILDER_WIDGET_BRANDING =
  "WorkflowBuilderWidgetAndBranding" as const;
export const ROUTE_WORKFLOW_BUILDER_WORKFLOW_AUTOMATION =
  "WorkflowBuilderWorkflowAutomation" as const;
export const ROUTE_WORKFLOW_ORCHESTRATION = "WorkflowOrchestration" as const;
export const ROUTE_WORKFLOW_TEMPLATE_LIST =
  "WorkflowBuilderTemplatesList" as const;
export const ROUTE_CONNECTED_ACCOUNTS = "ConnectedAccounts" as const;
export const ROUTE_CONNECTED_ACCOUNTS_VIEW = "ConnectedAccountsView" as const;
export const ROUTE_BORROWER_PLATFORM_BUILDER_VIEW =
  "BorrowerPlatformBuilderView" as const;
export const ROUTE_BORROWER_PLATFORM_TEMPLATE_EDITOR =
  "BorrowerPlatformTemplateEdit" as const;
export const ROUTE_EMAIL_BRANDING_SELECT = "EmailBranding-Select" as const;
export const ROUTE_COMMAND_BAR_SETTINGS = "CommandBarSettings" as const;
export const ROUTE_BUILDERS_BASE = "BuildersBase" as const;
export const ROUTE_REGISTER = "Register" as const;

const routeNames = {
  ROUTE_HOME,
  ROUTE_INBOX,
  ROUTE_INBOX_CALLS,
  ROUTE_ACCOUNT,
  ROUTE_AI_AGENTS,
  ROUTE_BORROWER_PLATFORM_BUILDER,
  ROUTE_BUSINESSES,
  ROUTE_BUSINESS_ENTITY_PROFILE,
  ROUTE_BUSINESS_PROFILE_DEALS,
  ROUTE_BUSINESS_PROFILE_INFO,
  ROUTE_BUSINESS_RELATIONS,
  ROUTE_BUSINESS_TRACKING,
  ROUTE_CHECKOUT_BUILDER,
  ROUTE_CLIENT_SETTINGS,
  ROUTE_CONTRACTS,
  ROUTE_CONTRACT_BUILDER,
  ROUTE_CONTRACT_BUILDER_EDIT,
  ROUTE_CONTRACT_BUILDER_NEW,
  ROUTE_CUSTOM_ATTRIBUTES_BUILDER_VIEW,
  ROUTE_CUSTOM_WEBHOOKS,
  ROUTE_CUSTOM_WEBHOOKS_VIEW,
  ROUTE_CUSTOM_WEBHOOKS_NEW,
  ROUTE_CUSTOM_WEBHOOKS_EDIT,
  ROUTE_DEALS,
  ROUTE_DEAL_ACTIVITY,
  ROUTE_DEAL_DOCUMENTS,
  ROUTE_DEAL_TRACKING,
  ROUTE_DEAL_LINKS,
  ROUTE_DEAL_PROGRESS,
  ROUTE_DOCUMENTS,
  ROUTE_EMAIL_INTEGRATION,
  ROUTE_EMAIL_TEMPLATES,
  ROUTE_KEYBOARD_SHORTCUTS,
  ROUTE_ACCESS_TOKENS,
  ROUTE_ACCESS_TOKENS_CREATE,
  ROUTE_EMAIL_TEMPLATES_EDIT,
  ROUTE_EMAIL_TEMPLATES_NEW,
  ROUTE_ERC_REPORTS,
  ROUTE_FUNDER_DETAILS,
  ROUTE_FUNDER_SETTINGS,
  ROUTE_INDIVIDUAL_PROFILE,
  ROUTE_INDIVIDUAL_PROFILE_DEALS,
  ROUTE_INDIVIDUAL_PROFILE_PERSONAL_INFO,
  ROUTE_INDIVIDUAL_PROFILE_TRACKING,
  ROUTE_INDIVIDUAL_RELATIONS,
  ROUTE_INTEGRATIONS,
  ROUTE_INTEGRATIONS_BORROWER_PLATFORM,
  ROUTE_INTEGRATIONS_DATA_PROVIDER,
  ROUTE_INTEGRATIONS_FUNDER,
  ROUTE_INTEGRATIONS_ORIGINATION,
  ROUTE_INTEGRATIONS_SERVICE_PROVIDER,
  ROUTE_INTEGRATIONS_WIDGET,
  ROUTE_ORCHESTRATION_LIST,
  ROUTE_ORCHESTRATION_TEMPLATE,
  ROUTE_ORGANIZATION,
  ROUTE_PAGE_NOT_FOUND,
  ROUTE_SCORECARDS_BACKTEST_REPORT_EDIT,
  ROUTE_SCORECARDS_BACKTEST_REPORT_VIEW,
  ROUTE_SCORECARDS_BUILDER_VIEW,
  ROUTE_SCORECARDS_GROUP_NEW,
  ROUTE_SMS_TEMPLATES_VIEW,
  ROUTE_SMS_TEMPLATES,
  ROUTE_SMS_TEMPLATES_EDIT,
  ROUTE_SMS_TEMPLATES_NEW,
  ROUTE_WIDGET_BRANDING,
  ROUTE_WIDGET_BRANDING_TEMPLATE,
  ROUTE_WIDGET_BRANDING_TEMPLATE_CREATE,
  ROUTE_WIDGET_BRANDING_CONSENT_TEMPLATE_LIST,
  ROUTE_WIDGET_BRANDING_CONSENT_TEMPLATE_EDIT,
  ROUTE_BUILDERS_CONSENT_TEMPLATE_LIST,
  ROUTE_BUILDERS_CONSENT_TEMPLATE_EDIT,
  ROUTE_WORKFLOW_BUILDER,
  ROUTE_WORKFLOW_BUILDER_CONTENT,
  ROUTE_WORKFLOW_BUILDER_NOTIFICATIONS_EMAIL,
  ROUTE_WORKFLOW_BUILDER_NOTIFICATIONS_SMS,
  ROUTE_WORKFLOW_BUILDER_NOTIFICATIONS_WEBHOOKS,
  ROUTE_WORKFLOW_BUILDER_SETTINGS,
  ROUTE_WORKFLOW_BUILDER_SETTINGS_VIEW,
  ROUTE_WORKFLOW_BUILDER_SUBMISSION,
  ROUTE_WORKFLOW_BUILDER_DOC_SYNC,
  ROUTE_WORKFLOW_BUILDER_ACTIVITY_HUB,
  ROUTE_WORKFLOW_BUILDER_WIDGET_BRANDING,
  ROUTE_WORKFLOW_BUILDER_WORKFLOW_AUTOMATION,
  ROUTE_WORKFLOW_ORCHESTRATION,
  ROUTE_WORKFLOW_TEMPLATE_LIST,
  ROUTE_CONNECTED_ACCOUNTS,
  ROUTE_CONNECTED_ACCOUNTS_VIEW,
  ROUTE_BORROWER_PLATFORM_BUILDER_VIEW,
  ROUTE_BORROWER_PLATFORM_TEMPLATE_EDITOR,
  ROUTE_EMAIL_BRANDING_SELECT,
  ROUTE_COMMAND_BAR_SETTINGS,
  ROUTE_BUILDERS_BASE,
  ROUTE_REGISTER,
};

export default routeNames;
